/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Pose_LoadingInputs */

const en_us2_body_assessment_pose_loading = /** @type {(inputs: Body_Assessment_Pose_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting the pose check ready…`)
};

const pt_br2_body_assessment_pose_loading = /** @type {(inputs: Body_Assessment_Pose_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando a conferência da pose…`)
};

const es_419_body_assessment_pose_loading = /** @type {(inputs: Body_Assessment_Pose_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando la revisión de la pose…`)
};

const pt_pt2_body_assessment_pose_loading = /** @type {(inputs: Body_Assessment_Pose_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A preparar a verificação da pose…`)
};

const fr_fr2_body_assessment_pose_loading = /** @type {(inputs: Body_Assessment_Pose_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préparation de la vérification de la pose…`)
};

const de_de2_body_assessment_pose_loading = /** @type {(inputs: Body_Assessment_Pose_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posenprüfung wird vorbereitet…`)
};

const it_it2_body_assessment_pose_loading = /** @type {(inputs: Body_Assessment_Pose_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparazione del controllo della posa…`)
};

/**
* | output |
* | --- |
* | "Getting the pose check ready…" |
*
* @param {Body_Assessment_Pose_LoadingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_pose_loading = /** @type {((inputs?: Body_Assessment_Pose_LoadingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Pose_LoadingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_pose_loading(inputs)
	if (locale === "es-419") return es_419_body_assessment_pose_loading(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_pose_loading(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_pose_loading(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_pose_loading(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_pose_loading(inputs)
	return en_us2_body_assessment_pose_loading(inputs)
});
export { body_assessment_pose_loading as "body-assessment.pose_loading" }